// Others
import { urlApiTask } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBodyUpdate } from '~/utils/interface/common';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IFormTask, IQueryParamTask, ITask } from '~/utils/interface/task';

const taskApi = {
  getListTask: (params: IQueryParamTask) => {
    const url = urlApiTask.getListTask;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITask[]>>>(url, { params });
  },

  createTask: (body: FormData) => {
    const url = urlApiTask.createTask;
    return axiosClient.post<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },
  detailTask: (taskId: string) => {
    const url = urlApiTask.detailTask(taskId);
    return axiosClient.get<IBaseResponse<ITask>>(url);
  },
  updateTask: (payload: IBodyUpdate<IFormTask>) => {
    const { id, body } = payload;
    const url = urlApiTask.updateTask(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },
  deleteTask: (taskId: string) => {
    const url = urlApiTask.deleteTask(taskId);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default taskApi;
